
export default {
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  }
}
